import React from "react";
import { boolean, func } from "prop-types";
import { translate } from "react-i18next";
import compose from "ramda/src/compose";
import { Modal } from "shared/components";
import OdinIncidentForm from "./OdinIncidentForm";
import IconRepair from "../../../../assets/svg/icone-reparo-modal.svg";

const ModalOdinIncident = (props) => {
  const { t, isCurrentStep, onPreviousStep, onNextStep, onReset } = props;
  return (
    <Modal
      isOpen={isCurrentStep}
      onClose={onReset}
      title={t("MSG_0194")}
      icon={IconRepair}
      ariaHideApp={false}
    >
      <OdinIncidentForm
        onPreviousStep={onPreviousStep}
        onNextStep={onNextStep}
        onReset={onReset}
      />
    </Modal>
  );
};

ModalOdinIncident.propTypes = {
  onCreateIncident: func.isRequired,
  onReset: func.isRequired,
  onPreviousStep: func.isRequired,
  onNextStep: func.isRequired,
  isOpen: boolean,
};

ModalOdinIncident.defaultProps = {
  isOpen: false,
};

const enhance = compose(translate());

export default enhance(ModalOdinIncident);



// WEBPACK FOOTER //
// ./src/components/RepairWizard/components/ModalOdinIncident/index.js